import React, { useState, useEffect, useCallback } from "react";
import Pagination from "@material-ui/lab/Pagination";
import PaginationItem from "@material-ui/lab/PaginationItem";

import "./permissions.scss";
import PermissionItem from "./components/PermissionItem";
import PermissionService from "../../../../services/PermissionsService";
import { Link, useLocation } from "react-router-dom";
import { calcCountPages, calcOffset } from "../../../../utils/pagination";
import EmptyResult from "../../../components/EmptyResult";
import ScreenHeader from "../../components/ScreenHeader";
import { useDispatch } from "react-redux";
import { showConfirmDialog } from "../../../../redux/actions/uiConfirmDialog";
import { Button } from "@material-ui/core";
import { showSnackBar } from "../../../../redux/actions/ui";
import SearchBox from "../../../components/SearchBox/SearchBox";

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function PermissionsScreen(props) {
  const permissionsLoading = Array.from(Array(5).keys());
  const [permissions, setPermissions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isAllActive, setIsAllActive] = useState(true);
  const dispatch = useDispatch();

  // pagination
  const location = useLocation();
  let query = useQuery();
  const [countPages, setCountPages] = useState(0);
  const page = parseInt(query.get("page")) || 1;
  const paginationLimit = 5;

  const fetchPermissionsData = useCallback(async (value) => {
    setIsLoading(true);
    try {
      const result = await PermissionService.listPermissions({
        fields: "id,course,can_upload_audio,can_upload_video,can_upload_images,can_upload_files,university,updated_by,created_datetime,modified_datetime",
        expand: "course",
        limit: paginationLimit,
        offset: calcOffset(page, paginationLimit)
      }, {course__name__icontains: value} );
      setPermissions(result.data.results);
      setCountPages(calcCountPages(result, paginationLimit));      
    } catch (error) {
      setPermissions([]);
    }
    setIsLoading(false);
  }, [page]);

  const fetchIsAllActive = useCallback(async () => {
    try {
      const result = await PermissionService.isAllActive();
      setIsAllActive(result.data.is_all_active);
    } catch (error) {
      setIsAllActive(false);
    }
  }, []);

  const handleIsAllActive = async (action) => {        
    setIsAllActive(action);
    try{
      if (action) {        
        await PermissionService.activateAll();
        dispatch(showSnackBar("Successfully activated!"));
      }else{
        await PermissionService.deactivateAll();
        dispatch(showSnackBar("Successfully deactivated!"));
      }      
    }catch (error) {
      // setIsLoading(false);
      dispatch(showSnackBar("An error occurred!", 'error'));
    }      
    await fetchPermissionsData();    
  };

  const handleClickOpenDialogChangeAll = () => {
    dispatch(
      showConfirmDialog(
        "Change this ?", 
        "It will affect all permissions!", 
        () => handleIsAllActive(!isAllActive),
        "No",
        "Yes, continue."
      )
    );
  };

  const updatePermissionFromList = async (id, data) => {
    const newPermissions = permissions.map((item, index) => {
      if (item.id === id) {
        return { ...item, ...data };
      }
      return item;
    });
    setPermissions(newPermissions);
    await fetchIsAllActive();
  };


  useEffect(() => {
    // Query Params changued
    fetchIsAllActive();
    fetchPermissionsData();
  }, [fetchIsAllActive, fetchPermissionsData, location.search]);

  return (
    <div
      id="course-screen"
      className={`${props.className} dashboard-container`}
    >
      {/* Header */}
      <ScreenHeader title="Permissions" children={
        <Button  onClick={handleClickOpenDialogChangeAll} type="submit" color="primary" variant="outlined">
          {isAllActive ? (
            "Deactivate all"
          ) : (            
            "Set all active"
          )}
        </Button>
      }/>

      {/* Body */}
      <div className="content">
        <SearchBox fetchData={fetchPermissionsData} placeholder="Search by course" />
        <div className="courses-list" style={{ minHeight: "36em" }}>
          {isLoading? (
            // Generate 5 courses of loading data
            permissionsLoading.map(i => <PermissionItem key={i} loading />)
          ) : // Show 
          permissions.length > 0 ? (
            permissions.map(permission => (
              <PermissionItem
                data={permission}
                key={permission.id}                
                openSnack={props.openSnack}
                onUpdatePermission={updatePermissionFromList}
              />
            ))
          ) : (
            // Show Empty courses
            <EmptyResult />
          )}
        </div>
        <Pagination
          page={page}
          count={countPages}
          color="primary"
          size="large"
          renderItem={item => (
            <PaginationItem
              component={Link}
              to={`/dashboard/permissions${
                item.page === 1 ? "" : `?page=${item.page}`
              }`}
              {...item}
            />
          )}
        />
      </div>
    </div>
  );
}

export default PermissionsScreen;
